import { cn } from "@bentolabs/kit/utils";

type Props = {
  className?: string;
};

export const Badge = ({ className }: Props) => {
  return (
    <div
      className={cn(
        "text-spearmint green-gradient flex items-center gap-2.5 rounded-xl p-3 text-sm",
        className
      )}
    >
      <span className="inline-flex leading-none opacity-50 select-none">
        TVL:
      </span>
      <span className="inline-flex leading-none">$40,152,767.30(HARDCODE)</span>
    </div>
  );
};
